/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMissingReferredProjectDeliverableRequest
 */
export interface CreateMissingReferredProjectDeliverableRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMissingReferredProjectDeliverableRequest
     */
    referredProjectId: string;
}

/**
 * Check if a given object implements the CreateMissingReferredProjectDeliverableRequest interface.
 */
export function instanceOfCreateMissingReferredProjectDeliverableRequest(value: object): value is CreateMissingReferredProjectDeliverableRequest {
    if (!('referredProjectId' in value) || value['referredProjectId'] === undefined) return false;
    return true;
}

export function CreateMissingReferredProjectDeliverableRequestFromJSON(json: any): CreateMissingReferredProjectDeliverableRequest {
    return CreateMissingReferredProjectDeliverableRequestFromJSONTyped(json, false);
}

export function CreateMissingReferredProjectDeliverableRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMissingReferredProjectDeliverableRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'referredProjectId': json['referredProjectId'],
    };
}

export function CreateMissingReferredProjectDeliverableRequestToJSON(value?: CreateMissingReferredProjectDeliverableRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'referredProjectId': value['referredProjectId'],
    };
}

